import { ICreateProductVariantPayload } from '@/interfaces/api/product/ICreateProductPayload';

export interface IVariantValidationErrors {
	[key: string]: string;
}

export const VARIANT_ERROR_MESSAGES = {
	NAME_REQUIRED: 'Variant name is required',
	SKU_REQUIRED: 'SKU is required',
	PRICE_POSITIVE: 'Price must be positive',
	INVENTORY_NON_NEGATIVE: 'Quantity must be non-negative',
	TYPE_REQUIRED: 'Type is required',
	GRAMS_NON_NEGATIVE: 'Weight must be non-negative',
	IMAGE_REQUIRED: 'Image is required',
} as const;

export const validateVariant = (
	variant: ICreateProductVariantPayload,
): IVariantValidationErrors => {
	const errors: IVariantValidationErrors = {};

	// Required field validations
	if (!variant.name?.trim()) {
		errors.name = VARIANT_ERROR_MESSAGES.NAME_REQUIRED;
	}

	if (!variant.sku?.trim()) {
		errors.sku = VARIANT_ERROR_MESSAGES.SKU_REQUIRED;
	}

	if (!variant.type?.trim()) {
		errors.type = VARIANT_ERROR_MESSAGES.TYPE_REQUIRED;
	}

	if (variant.price <= 0) {
		errors.price = VARIANT_ERROR_MESSAGES.PRICE_POSITIVE;
	}

	if (variant.inventoryQty < 0) {
		errors.inventoryQty = VARIANT_ERROR_MESSAGES.INVENTORY_NON_NEGATIVE;
	}

	if (variant.grams < 0) {
		errors.grams = VARIANT_ERROR_MESSAGES.GRAMS_NON_NEGATIVE;
	}

	if (!variant.image?.trim()) {
		errors.image = VARIANT_ERROR_MESSAGES.IMAGE_REQUIRED;
	}

	return errors;
};

export const hasValidationErrors = (
	errors: IVariantValidationErrors,
): boolean => {
	return Object.keys(errors).length > 0;
};
